export default __webpack_public_path__ + "maps-guides-styles-layers-raster-layer-1200-2fdbb7b96dc6cd75e80bdbbeb0bfbafa.png";